import React from "react";
import { Link } from "react-router-dom";

function Error() {
  return (
    <div className="error page-100">
      <section>
        <h1>404</h1>
        <h3>Sorry, the page you tried cannot be found</h3>
        <Link to="/" className="btn-large">
          back home
        </Link>
      </section>
    </div>
  );
}

export default Error;
